import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AGUIconDotLegendEntry, AGUResultCount, AGUSortOption, FormatCountLine, IconDotLegend } from 'agu_app_shell';

/**
 * The results column's toolbar — the mockup's `.toolbar`: the row directly above
 * the results holding the `Sort: <value>` chip, at the same `16px 0 18px` rhythm
 * as the filter rail's head so the two line up across the column gap.
 *
 * It is deliberately NOT the tab strip's home: the mockup's `.viewtabs` sit
 * full-width above the whole results shell (rail included), so each page renders
 * `agu-tab-strip` itself and only the sort control lives here (ruling R-F8).
 *
 * Filters left too — the persistent `agu-filter-rail` replaced the
 * `mj-filter-popover` this component used to open. What remains is the
 * mockup's result-count line (`<b>N</b> grants · showing 1 to 9`, grants.html:960)
 * on the left and the sort control on the right.
 */
@Component({
    standalone: false,
    selector: 'ra-finder-toolbar',
    templateUrl: './ra-finder-toolbar.component.html',
    styleUrl: './ra-finder-toolbar.component.scss',
})
export class RaFinderToolbarComponent {
    @Input({ required: true }) Sort!: string;
    @Input({ required: true }) SortOptions!: ReadonlyArray<{ key: string; label: string }>;
    @Input() Count: AGUResultCount | null = null;

    @Output() SortChange = new EventEmitter<string>();

    /**
     * The phone legend's entries: Recommended and New. Visa joins only when a visa tag is on screen (P/Member_Hub.html:1000), and no
     * Research Accelerator card renders one — the job model carries no sponsorship field.
     */
    readonly Legend: readonly AGUIconDotLegendEntry[] = IconDotLegend(false);

    /** The pages describe their sorts in MJ's `{key,label}` shape; the chrome speaks the portal's own. */
    get TriggerOptions(): AGUSortOption[] {
        return this.SortOptions.map((option) => ({ Key: option.key, Label: option.label }));
    }

    get CountLine(): { Bold: string | null; Text: string } | null {
        return this.Count ? FormatCountLine(this.Count) : null;
    }
}
